import React from 'react';
import './news.scss';
import Icon from '../Icon/Icon';
// const newsData = {
//   "action": "success",
//   "data": {
//     "name": "heavy rainfall",
//     "pageName": "homepage",
//     "news": "Delivery may take longer due to heavy rainfall",
//     "status": false,
//     "gradientStartColor": "#43abd0",
//     "gradientStartPercent": 14,
//     "gradientEndColor": "#3d8bc6",
//     "gradientEndPercent": 85,
//     "gradientVertical": false,
//     "gradientWeb": "linear-gradient(99deg, #43abd0 14%, #3d8bc6 85%)",
//     "angle": 99,
//     "textColor": "#ffffff",
//     "apiUri": "/api/news",
//     "icon": "https://ik.imagekit.io/iwcam3r8ka/prod/news/202008/e7a33fe6-0a2f-440e-b1ee-1c7f41a25932.svg"
//   }
// };

const News = ({ newsData }) => {
  if (!newsData) return false;
  const { gradientWeb: background, news, icon, textColor: color } = newsData;
  const newsStyle = { background, color };
  return (
    <div className="news" style={newsStyle}>
      {icon && <Icon size={33} src={icon} class="news--image" />}
      <div className="news--text">{news}</div>
    </div>
  );
};

export default News;
